import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const phoneNumber = '213782367184';
  const message = encodeURIComponent('Bonjour Bloom Lingerie! Je souhaite avoir plus d\'informations.');
  
  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-button"
      aria-label="Contacter sur WhatsApp"
    >
      <MessageCircle size={24} className="text-white" fill="white" />
    </a>
  );
};
